import {
  Observable,
  of,
  Subscriber,
} from 'rxjs';

import {
  Button,
  Column,
  Form,
} from '@rs-bank/rs-layout';

import { WizardDataStep } from '../../../../../shared/wizard-v2/wizard-core/steps/base-step-types/wizard-data-step';
import { Reference, ReferenceGroupLanguage } from '../../references.entities';
import { ReferencesGroupWizardComponent } from '../references-group-wizard.component';

export class ReferenceSecondStep extends WizardDataStep<ReferencesGroupWizardComponent, ReferenceGroupLanguage | undefined> {

	public override onInit(lang: ReferenceGroupLanguage | undefined): Observable<void> {
		this.wizard.title = this.wizardComponent.group.name;
		this.goBackVisibleForStep = this.wizard.stepIndex !== 0;
		this.stepInformation.defaultButtonsHidden.next(true);

		const referenceList: Array<Reference> = (lang ? this.wizardComponent.group.multilangReference![lang] : this.wizardComponent.group.references) || [];

		return this.createLayout(referenceList)
	}

	public override onExecute(): Observable<void> {
		return of(undefined);
	}

	public override prepareBack(): Observable<void> {
		this.wizard.title = this.wizardComponent.group.name;

		return super.prepareBack();
	}

	public createLayout(referenceList: Array<Reference>): Observable<void> {
		return new Observable((subscriber: Subscriber<void>) => {

			this.layoutForm = new Form(
				'Выберите справку',
				new Column(
					referenceList.map((item: Reference) => {
						return new Button(
							item.referenceName,
							() => this.wizard.next(item),
							of(false),
							{
cssClassList: [
'button-in-list',
'button-choose-reference',
],
},
						)
					}),
				),
				undefined,
			)

			subscriber.next();
			subscriber.complete();
		})
	}
}